// The seat a scribe chose in a multi-seat class, kept per class in
// sessionStorage so a reload mid-ride doesn't drop them back into the other
// judge's sheet. The key carries no user sub (existing readers and Cypress
// seed it by classId), so #2090: fullSignOut MUST clear every entry, or the
// next scribe on a shared kiosk tab inherits the previous scribe's seat pick
// with no picker shown and scores under the wrong judge's sheet.
export const POSITION_CHOICE_PREFIX = "scribe-fe.position.";

export const choiceKey = (classId) => `${POSITION_CHOICE_PREFIX}${classId}`;

export function readChoice(classId) {
  if (!classId) return null;
  try {
    return sessionStorage.getItem(choiceKey(classId));
  } catch {
    return null;
  }
}

export function writeChoice(classId, position) {
  if (!classId) return;
  try {
    sessionStorage.setItem(choiceKey(classId), position);
  } catch {
    // sessionStorage unavailable (private browsing): the choice just won't
    // survive a reload.
  }
}

// #2090: drop every remembered seat choice (all classes).
export function clearPositionChoices() {
  try {
    const keys = [];
    for (let i = 0; i < sessionStorage.length; i += 1) {
      const k = sessionStorage.key(i);
      if (k && k.startsWith(POSITION_CHOICE_PREFIX)) keys.push(k);
    }
    keys.forEach((k) => sessionStorage.removeItem(k));
  } catch {
    // Storage may be unavailable: non-fatal.
  }
}
